import React from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, Navigate } from 'react-router-dom';
import ComptabiliteAlertsPage from './ComptabiliteAlertsPage';
import EcrituresComptablesPage from './EcrituresComptablesPage';
import PlanComptablePage, {
  AuxiliairesPage,
  OperationsAndCodesPage,
  CodesPage,
  CodesAffectationPage,
} from './PlanComptablePage';
import BalanceGeneralePage from './BalanceGeneralePage';
import GrandLivrePage from './GrandLivrePage';
import JournalComptablePage from './JournalComptablePage';
import BilanSituationPage from './BilanSituationPage';
import CompteResultatSituationPage from './CompteResultatSituationPage';
import FluxTresorerieSituationPage from './FluxTresorerieSituationPage';
import AssetsPage from './AssetsPage';
import AnnexesSituationPage from './AnnexesSituationPage';
import RapportsperiodiquesPage from './RapportsperiodiquesPage';
import ComparatifsEvolutionPage from './ComparatifsEvolutionPage';
import ClotureComptablePage from './ClotureComptablePage';
import DeclarationsFiscalesPage from './DeclarationsFiscalesPage';
import LiasseFiscalePage from './15-liasse-fiscale';
import ConformiteAuditPage from './ConformiteAuditPage';
import TaxesSupplementairesPage from './TaxesSupplementairesPage';
import IfrsSupportPage from './IfrsSupportPage';
import SecteursSpecialisesPage from './SecteursSpecialisesPage';
import AnalysesRapportsPage from './AnalysesRapportsPage';
import DocumentsPage from './DocumentsPage';
import ComptabiliteConfigPage, { ConfigurationSituationPage } from './ComptabiliteConfigPage';
import AccountingDashboardPage from './AccountingDashboardPage';

/**
 * Accounting module shell — routes aligned with saudiModuleStructure.js (Saudi ERP).
 * Primary paths: dashboard, entries, chart-accounts, balance-generale, grand-livre,
 * bilan, compte-resultat, tax-declarations, analyses-rapports, config.
 */
const ComptabiliteMainPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.comptabilite.pages.comptabiliteMainPage.${key}`, opts);

  return (
    <div aria-label={p('title')}>
    <span className="sr-only">{p('subtitle')}</span>
    <Routes>
      <Route path="/" element={<Navigate to="/comptabilite/dashboard" replace />} />
      <Route path="/dashboard" element={<AccountingDashboardPage />} />
      <Route path="/alertes" element={<ComptabiliteAlertsPage />} />

      <Route path="/entries" element={<EcrituresComptablesPage />} />

      <Route path="/chart-accounts" element={<PlanComptablePage />} />
      <Route path="/auxiliaires" element={<AuxiliairesPage />} />
      <Route path="/operations-codes" element={<OperationsAndCodesPage />} />
      <Route path="/codes" element={<CodesPage />} />
      <Route path="/codes-affectation" element={<CodesAffectationPage />} />

      <Route path="/balance-generale" element={<BalanceGeneralePage />} />
      <Route path="/trial-balance" element={<Navigate to="/comptabilite/balance-generale" replace />} />
      <Route path="/grand-livre" element={<GrandLivrePage />} />
      <Route path="/journal" element={<JournalComptablePage />} />
      <Route path="/journal-comptable" element={<Navigate to="/comptabilite/journal" replace />} />
      <Route path="/bilan" element={<BilanSituationPage />} />
      <Route path="/bilan-comptable" element={<Navigate to="/comptabilite/bilan" replace />} />
      <Route path="/compte-resultat" element={<CompteResultatSituationPage />} />
      <Route path="/resultat" element={<Navigate to="/comptabilite/compte-resultat" replace />} />
      <Route path="/flux" element={<FluxTresorerieSituationPage />} />
      <Route path="/flux-tresorerie" element={<Navigate to="/comptabilite/flux" replace />} />

      <Route path="/balance-sheet" element={<Navigate to="/comptabilite/bilan" replace />} />
      <Route path="/income-statement" element={<Navigate to="/comptabilite/compte-resultat" replace />} />
      <Route path="/cash-flow" element={<Navigate to="/comptabilite/flux" replace />} />
      <Route path="/annexes-notes" element={<Navigate to="/comptabilite/annexes" replace />} />
      <Route path="/reports" element={<Navigate to="/comptabilite/rapports" replace />} />
      <Route path="/rapports-periodiques" element={<Navigate to="/comptabilite/rapports" replace />} />

      <Route path="/assets" element={<AssetsPage />} />
      <Route path="/annexes" element={<AnnexesSituationPage />} />
      <Route path="/rapports" element={<RapportsperiodiquesPage />} />
      <Route path="/comparatifs" element={<ComparatifsEvolutionPage />} />
      <Route path="/comparatifs-evolution" element={<Navigate to="/comptabilite/comparatifs" replace />} />
      <Route path="/cloture" element={<ClotureComptablePage />} />
      <Route path="/cloture-comptable" element={<Navigate to="/comptabilite/cloture" replace />} />

      <Route path="/tax-declarations" element={<DeclarationsFiscalesPage />} />
      <Route path="/compliance" element={<ConformiteAuditPage />} />
      <Route path="/liasse-fiscale" element={<LiasseFiscalePage />} />
      <Route path="/monthly-results" element={<Navigate to="/comptabilite/analyses-rapports" replace />} />
      <Route path="/analyses-rapports" element={<AnalysesRapportsPage />} />
      <Route path="/additional-taxes" element={<TaxesSupplementairesPage />} />
      <Route path="/ifrs-support" element={<IfrsSupportPage />} />
      <Route path="/specialized-sectors" element={<SecteursSpecialisesPage />} />

      <Route path="/documents" element={<DocumentsPage />} />

      <Route path="/advanced-utilities" element={<Navigate to="/comptabilite/config" replace />} />
      <Route path="/config" element={<ComptabiliteConfigPage />} />
      <Route path="/situation-config" element={<ConfigurationSituationPage />} />

      <Route path="/*" element={<Navigate to="/comptabilite/entries" replace />} />
    </Routes>
    </div>
  );
};

export default ComptabiliteMainPage;
